import { useCallback, useContext, useEffect, useState } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { ProgramNames } from '@/models/Program';

import RowWrap from './IntakeRowWrap';
import SignUpNames from '../../SignUpNames';

function PartnerNameInput() {
  const {
    partnerInfo,
    partnerGroupInfo,
    showErrors,
    intakeLabels,
    selectedProgramInfo,
    updatePartnerInfo,
    updatePartnerGroupInfo,
  } = useContext(PartnerIntakeContext);

  const { translatedText } = useContext(LocaleContext);
  const [partnerName, setPartnerName] = useState<string | null>(null);

  function isNameValid(name: string | null) {
    return name == null || name?.length <= 2;
  }

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedPartnerName = event.target.value;

      setPartnerName(updatedPartnerName);

      if (updatePartnerInfo != null) {
        updatePartnerInfo({
          ...partnerInfo,
          partnerName: updatedPartnerName,
        });
      }

      const partnerGroupNameShouldBeSame =
        (selectedProgramInfo.id === ProgramNames.TreeCampusHealthcare &&
          (partnerInfo.healthcareSystem == null || !partnerInfo.healthcareSystem)) ||
        (selectedProgramInfo.id === ProgramNames.TreeCampusK12 &&
          (partnerInfo.schoolDistrict == null || !partnerInfo.schoolDistrict));

      if (updatePartnerGroupInfo != null && partnerGroupNameShouldBeSame) {
        updatePartnerGroupInfo({
          ...partnerGroupInfo,
          partnerName: updatedPartnerName,
        });
      }
    },
    [updatePartnerInfo, selectedProgramInfo, partnerInfo, updatePartnerGroupInfo, partnerGroupInfo]
  );

  useEffect(() => {
    setPartnerName(partnerInfo?.partnerName ?? null);
  }, [partnerInfo?.partnerName]);

  return (
    <RowWrap>
      <SignUpNames
        label={intakeLabels?.partnerName ?? ''}
        id={'partnerName'}
        value={partnerName}
        onChange={handleChange}
        error={showErrors && isNameValid(partnerName)}
        helperText={
          showErrors && isNameValid(partnerName) ? translatedText.signup.helperNameError : ''
        }
      />
    </RowWrap>
  );
}

export default PartnerNameInput;
